import ResidentMain from './ResidentMain';

export default ResidentMain;